import messages from './messages';

export default function thicknessDisplayName(thickness, itemMeasureImperial, useImperialUnits) {
  if(useImperialUnits){
    return [`${thickness}`, ' ', messages.mmUnit, ' ', itemMeasureImperial];
  } else{
    return [`${thickness}`, ' ', messages.mmUnit];
  }
}
